import { videos } from '@/mocks/videos';
import VideoCard from './VideoCard';

export default function FeaturedSection() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);
  const newVideos = videos.filter((v) => v.isNew).slice(0, 6);
  const topRated = [...videos].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <>
      <section className="px-4 md:px-6 py-8 md:py-10 bg-background-100/50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100">
              <i className="ri-fire-line text-lg text-primary-600"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">热门推荐</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
            {hotVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-8 md:py-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-sparkling-line text-lg text-accent-600"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">最新上线</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
            {newVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-8 md:py-10 bg-background-100/50">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100">
              <i className="ri-star-line text-lg text-secondary-600"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">高分必看</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
            {topRated.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-8 md:py-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200">
              <i className="ri-shield-check-line text-lg text-foreground-600"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">平台优势</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { icon: 'ri-hd-line', title: '高清画质', desc: '1080P超清画质，观影体验升级' },
              { icon: 'ri-speed-up-line', title: '极速加载', desc: '不缓冲不卡顿，流畅播放在线观看' },
              { icon: 'ri-global-line', title: '多源聚合', desc: '红桃视频、樱桃视频、茄子视频、糖心视频一站看全' },
              { icon: 'ri-timer-line', title: '实时更新', desc: '最新电视剧、电影大全每日同步更新' },
            ].map((item) => (
              <div key={item.title} className="p-5 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3">
                  <i className={`${item.icon} text-xl text-primary-600`}></i>
                </div>
                <h4 className="font-heading font-semibold text-foreground-900 mb-2">{item.title}</h4>
                <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}